module.exports = __webpack_public_path__ + "img/accountregist_icon.61e99acc.png";